import { j as a, a as o } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { translate as s } from "../../../../string-table.js";
import { Colors as p } from "../../../../1-foundations/Colors/Colors.js";
import { I as r } from "../../../../../Icon-D8QUNSZR.js";
import { I as E } from "../../../../../FeatureFlagProvider-BBppjvNP.js";
import "react";
import "@ionic/react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { Section as S } from "../Section/Section.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../../../css/ClassroomPreferences.css';const L = "_container_1i3rl_1", h = {
  container: L,
  "content-title": "_content-title_1i3rl_9",
  "content-no-info": "_content-no-info_1i3rl_13"
}, d = {
  datomic: {
    "infant-toddler": "infant,toddler",
    ece: "pre-k,tk",
    "k-2": "k,1,2",
    "3-5": "3,4,5",
    "6-8": "6,7,8",
    "9-12": "9,10,11,12",
    adult: "adult",
    na: "na"
  },
  valueTypes: {
    infant: "infant-toddler",
    toddler: "infant-toddler",
    "pre-k": "ece",
    tk: "ece",
    k: "k-2",
    1: "k-2",
    2: "k-2",
    3: "3-5",
    4: "3-5",
    5: "3-5",
    6: "6-8",
    7: "6-8",
    8: "6-8",
    9: "9-12",
    10: "9-12",
    11: "9-12",
    12: "9-12",
    adult: "adult",
    na: "na"
  },
  display: {
    "infant-toddler": "Infant and Toddler",
    infant: "Infant and Toddler",
    toddler: "Infant and Toddler",
    ece: "Pre-K and TK",
    "pre-k": "Pre-K and TK",
    tk: "Pre-K and TK",
    k: "K to 2nd",
    1: "K to 2nd",
    2: "K to 2nd",
    3: "3rd to 5th",
    4: "3rd to 5th",
    5: "3rd to 5th",
    6: "6th to 8th",
    7: "6th to 8th",
    8: "6th to 8th",
    9: "9th to 12th",
    10: "9th to 12th",
    11: "9th to 12th",
    12: "9th to 12th",
    adult: "Adult Education",
    na: "Not Relevant"
  }
}, O = {
  "gen-ed": "General Education",
  elective: "Electives (Music, Art, etc.)",
  english: "English/Language Arts",
  "physical-education": "Health/Physical Education",
  "social-studies": "History/Social Studies",
  math: "Math",
  science: "Science",
  "special-education": "Special Education",
  "world-languages": "World Languages",
  other: "Other",
  "not-sure": "I'm not sure yet",
  na: "Not Relevant"
}, I = {
  english: "English",
  spanish: "Spanish",
  mandarin: "Chinese (Mandarin)",
  cantonese: "Chinese (Cantonese)",
  french: "French",
  tagalog: "Tagalog",
  vietnamese: "Vietnamese",
  arabic: "Arabic",
  korean: "Korean",
  japanese: "Japanese",
  german: "German",
  asl: "American Sign Language",
  other: "Other"
};
function f(t, n) {
  if (!t || t.length === 0) return;
  const e = Array.from(new Set(t.map((i) => n[i])));
  if (n === d.display)
    return e.sort((i, l) => m(i) - m(l));
  const c = Object.values(n).reduce((i, l, _) => (i[l] = _, i), {});
  return e.sort((i, l) => c[i] - c[l]);
}
function M(t, n) {
  return n === d.datomic ? t.map((e) => n[e]) : JSON.parse(t).map((e) => e);
}
function P(t) {
  var u, c, i;
  const {
    editable: n,
    classroomPreferences: e
  } = t;
  return /* @__PURE__ */ a(S, {
    title: s("SUB_PROFILE_CLASSROOM_PREFERENCES_HEADER"),
    children: /* @__PURE__ */ o("div", {
      className: h.container,
      children: [/* @__PURE__ */ a(E, {
        content: /* @__PURE__ */ o("div", {
          children: [/* @__PURE__ */ o("span", {
            className: h["content-title"],
            children: [s("SUB_PROFILE_CLASSROOM_PREFERENCES_LABEL_GRADE_LEVEL"), ":", " "]
          }), g(f((u = e == null ? void 0 : e.gradeLevels) == null ? void 0 : u.value, d.display))]
        }),
        leftIcon: /* @__PURE__ */ a(r, {
          name: "Grad Cap"
        }),
        ...n != null && n.isEditable ? {
          rightIcon: {
            icon: /* @__PURE__ */ a(r, {
              name: "Edit",
              color: p.blue500
            }),
            onClick: n.onEditGradeLevel
          }
        } : {}
      }), /* @__PURE__ */ a(E, {
        content: /* @__PURE__ */ o("div", {
          children: [/* @__PURE__ */ o("span", {
            className: h["content-title"],
            children: [s("SUB_PROFILE_CLASSROOM_PREFERENCES_LABEL_SUBJECTS"), ":", " "]
          }), g(f((c = e == null ? void 0 : e.subjects) == null ? void 0 : c.value, O))]
        }),
        leftIcon: /* @__PURE__ */ a(r, {
          name: "Book"
        }),
        ...n != null && n.isEditable ? {
          rightIcon: {
            icon: /* @__PURE__ */ a(r, {
              name: "Edit",
              color: p.blue500
            }),
            onClick: n.onEditSubjects
          }
        } : {}
      }), /* @__PURE__ */ a(E, {
        content: /* @__PURE__ */ o("div", {
          children: [/* @__PURE__ */ o("span", {
            className: h["content-title"],
            children: [s("SUB_PROFILE_CLASSROOM_PREFERENCES_LABEL_LANGUAGES"), ":", " "]
          }), g(f((i = e == null ? void 0 : e.languages) == null ? void 0 : i.value, I))]
        }),
        leftIcon: /* @__PURE__ */ a(r, {
          name: "Chat Bubble Active"
        }),
        ...n != null && n.isEditable ? {
          rightIcon: {
            icon: /* @__PURE__ */ a(r, {
              name: "Edit",
              color: p.blue500
            }),
            onClick: n.onEditLanguages
          }
        } : {}
      })]
    })
  });
}
function g(t) {
  return t ? /* @__PURE__ */ a("span", {
    children: t.join(", ")
  }) : /* @__PURE__ */ a("span", {
    className: h["content-no-info"],
    children: s("SUB_PROFILE_NO_INFORMATION")
  });
}
function m(t) {
  return Object.keys(d.display).indexOf(Object.keys(d.display).find((e) => d.display[e] === t) ?? "");
}
export {
  P as ClassroomPreferences,
  f as convertPreferencesToDisplay,
  M as convertPreferencesToSave,
  m as getGradeLevelIndex,
  d as gradeLevelMappings,
  I as languageMapper,
  O as subjectMapper
};
